import { PropsWithChildren, useEffect, useState } from "react"
import { createPortal } from "react-dom"

export { getSelectedTextPosition } from "./textSelection"
export { applyTheme, checkIfDarkMode, getThemeMode, syncThemeColor } from "./toggleTheme"
export type { ThemeMode } from "./toggleTheme"
export { setZoomableImages } from "./zoom"
export { subscribeMailChimp } from "./subscribe"
export { smoothAnchorScroll } from "./scroll"
export { dispatchCustomEvent } from "./customEvent"

export const copyToClipboard = (toCopy: string): void => {
  const el = document.createElement(`textarea`)
  el.value = toCopy
  el.setAttribute(`readonly`, ``)
  el.style.position = `absolute`
  el.style.left = `-9999px`
  document.body.appendChild(el)
  el.select()
  navigator.clipboard.writeText(toCopy)
  document.body.removeChild(el)
}

export const Portal = ({
  mount,
  children,
}: PropsWithChildren<{ mount?: HTMLElement }>) => {
  const [target, setTarget] = useState<HTMLElement | null>(null)

  useEffect(() => {
    setTarget(mount || document.body)
  }, [mount])

  return target ? createPortal(children, target) : null
}

export const objectToGetParams = (
  object: Record<string, string | number | undefined | null>
): string => {
  const params = Object.entries(object)
    .filter(([, value]) => value !== undefined && value !== null)
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`
    )
  return params.length > 0 ? `?${params.join("&")}` : ""
}
